module.exports = __webpack_public_path__ + "img/20240531_2.3de3e482.jpg";